import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getvendorCategoriesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "vendorCategories", ...action.payload }),
		);
		yield put({
			type: types.GET_VENDOR_CATEGORIES_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_VENDOR_CATEGORIES_ERROR,
			payload,
		});
	}
}

export function* getvendorCategoriesWatcherSaga() {
	yield takeLatest(
		types.GET_VENDOR_CATEGORIES_START,
		getvendorCategoriesHandlerSaga,
	);
}

//create

//delete

function* deletevendorCategoriesHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("vendorCategories", action.payload),
		);
		yield put({
			type: types.DELETE_VENDOR_CATEGORIES_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_VENDOR_CATEGORIES_ERROR,
			payload,
		});
	}
}

export function* deletevendorCategoriesWatcherSaga() {
	yield takeLatest(
		types.DELETE_VENDOR_CATEGORIES_START,
		deletevendorCategoriesHandlerSaga,
	);
}

//update
